export const translateAuthError = (message: string): string => {
    const errorMap: { [key: string]: string } = {
        'Invalid login credentials': 'Email ou mot de passe incorrect.',
        'User not found': 'Utilisateur non trouvé.',
        'Email not confirmed': 'Email non confirmé. Veuillez vérifier votre boîte de réception.',
        'Password should be at least 6 characters': 'Le mot de passe doit contenir au moins 6 caractères.',
        'User already registered': 'Cette adresse email est déjà utilisée.',
        'Invalid email structure': 'L\'adresse email n\'est pas valide.',
        'New password should be different from the old one': 'Le nouveau mot de passe doit être différent de l\'ancien.',
        'Too many requests': 'Trop de tentatives. Veuillez réessayer plus tard.',
        'Invalid token': 'Lien invalide ou expiré.',
        'Email link is invalid or has expired': 'Le lien email est invalide ou a expiré.',
        'Database error saving new password': 'Erreur lors de l\'enregistrement du nouveau mot de passe.',
        'User not found for the given reset link': 'Utilisateur non trouvé pour ce lien de réinitialisation.',
        'Confirmation token not found': 'Jeton de confirmation introuvable.',
        'Token has expired or is invalid': 'Le jeton a expiré ou est invalide.',
        'email rate limit exceeded': 'Limite d\'envoi atteinte. Veuillez patienter quelques minutes avant de réessayer.',
        'Rate limit exceeded': 'Trop de tentatives. Veuillez patienter.'
    };

    // Check for exact match or substring
    for (const [key, value] of Object.entries(errorMap)) {
        if (message.includes(key)) {
            return value;
        }
    }

    return message || 'Une erreur inattendue est survenue.';
};
